export default "__VITE_ASSET__e73a34f9__"